import { DateTime } from 'luxon';
import { ProductType } from '../../../models/product-type.enum';
import type { IProduct } from '../../../models/product.model';
import { TravellerCategory } from '../../../models/traveller-category.enum';
import type TimeValidityViewModel from './time-validity.view-model';
import TariffZoneViewModel from './tariff-zone.view-model';

export default class ProductViewModel {
  public productId!: number;
  public productName!: string;
  public productType!: string;
  public travellerCategory!: string;
  public priceInSek?: number | undefined;
  public timeValidity!: TimeValidityViewModel;
  public tariffZones!: TariffZoneViewModel[];

  public static mapToBusinessModel(m: ProductViewModel): IProduct {
    return {
      productId: m.productId,
      productName: m.productName,
      productType: ProductViewModel.parseProductType(m.productType),
      travellerCategory: ProductViewModel.parseTravellerCategory(m.travellerCategory),
      priceInSek: m.priceInSek,
      timeValidity: {
        type: m.timeValidity.type,
        amount: m.timeValidity.amount,
        unit: m.timeValidity.unit,
        fromDate: m.timeValidity.fromDate ? DateTime.fromISO(m.timeValidity.fromDate) : undefined,
        toDate: m.timeValidity.toDate ? DateTime.fromISO(m.timeValidity.toDate) : undefined,
        fromDateTime: m.timeValidity.fromDateTime ? DateTime.fromISO(m.timeValidity.fromDateTime) : undefined,
        toDateTime: m.timeValidity.toDateTime ? DateTime.fromISO(m.timeValidity.toDateTime) : undefined,
      },
      tariffZones: m.tariffZones?.map((tz) => TariffZoneViewModel.mapToBusinessModel(tz)) ?? [],
    };
  }

  private static parseProductType(input: string): ProductType {
    switch (input.toLowerCase()) {
      case 'singleticket':
        return ProductType.singleTicket;
      case 'prepaidticket':
        return ProductType.prepaidTicket;
      case 'periodticket':
        return ProductType.periodTicket;
      case 'dayticket':
        return ProductType.dayTicket;
      case 'flexticket':
        return ProductType.flexTicket;
      case 'partialyearticket':
        return ProductType.partialYearTicket;
      case 'leisureticket':
        return ProductType.leisureTicket;
      default:
        return ProductType.unknown;
    }
  }

  private static parseTravellerCategory(input: string): TravellerCategory {
    switch (input.toLowerCase()) {
      case 'adult':
        return TravellerCategory.adult;
      case 'youth':
        return TravellerCategory.youth;
      default:
        return TravellerCategory.unknown;
    }
  }
}
